import { useEffect, useMemo } from 'react';

import { IProps } from './types';

/** При дизейбле всех свойств кроме одного, выбирает оставшееся свойство
 * и очищает значение если доступно более 1 свойства **/
export const useSelectSingleAvailableValue = ({ source, value, onChange, isDirty }: IProps) => {
  const isSingleOptionAvailable = useMemo(() => source?.filter(item => !item.disabled).length === 1, [source]);

  useEffect(() => {
    if (isSingleOptionAvailable) {
      const checkedOption = source?.find(item => !item.disabled);
      if (checkedOption) {
        onChange(checkedOption.value);
      }
    } else {
      if (value && isDirty) {
        onChange();
      }
    }
  }, [isSingleOptionAvailable, onChange]);
};
